import { useEffect, useRef } from "react";
import { ArrowUpRight, Github, Linkedin, Mail } from "lucide-react";
import { gsap } from "@/animations/gsap";
import { createTextReveal } from "@/animations/textReveal";
import { usePrefersReducedMotion } from "@/hooks/usePrefersReducedMotion";
import { contact } from "@/data/socials";
import { Magnetic } from "@/components/ui/Magnetic";

export function Contact() {
  const ref = useRef<HTMLElement>(null);
  const reduced = usePrefersReducedMotion();

  useEffect(() => {
    if (reduced) return undefined;
    const ctx = gsap.context(() => {
      createTextReveal(".contact-heading .mask-line > span", ref.current!);
    }, ref);
    return () => ctx.revert();
  }, [reduced]);

  const actions = [
    { label: "EMAIL ME", href: `mailto:${contact.email}`, icon: Mail, primary: true, testid: "contact-email" },
    { label: "LINKEDIN", href: contact.linkedin, icon: Linkedin, primary: false, testid: "contact-linkedin" },
    { label: "GITHUB", href: contact.github, icon: Github, primary: false, testid: "contact-github" },
  ];

  return (
    <section id="contact" ref={ref} className="container-x section-y" data-testid="contact-section">
      <p className="eyebrow">08 — CONTACT</p>
      <h2 className="contact-heading font-display mt-10 text-[clamp(2.6rem,7vw,6.5rem)] font-semibold uppercase leading-[0.98] tracking-tight" data-testid="contact-heading">
        <span className="mask-line">
          <span>HAVE A COMPLEX</span>
        </span>
        <span className="mask-line">
          <span>ENGINEERING PROBLEM?</span>
        </span>
        <span className="mask-line">
          <span className="text-accent">LET'S TALK.</span>
        </span>
      </h2>
      <div className="mt-16 flex flex-wrap gap-5" data-testid="contact-actions">
        {actions.map(({ label, href, icon: Icon, primary, testid }) => (
          <Magnetic key={label}>
            <a
              href={href}
              target={href.startsWith("mailto:") ? undefined : "_blank"}
              rel="noopener noreferrer"
              className={`btn ${primary ? "btn-primary" : "btn-ghost"}`}
              data-testid={testid}
              title={`${label} — placeholder link, update in src/data/socials.ts`}
            >
              <Icon size={16} aria-hidden="true" />
              {label}
              <ArrowUpRight size={16} aria-hidden="true" />
            </a>
          </Magnetic>
        ))}
      </div>
    </section>
  );
}
